export default __webpack_public_path__ + "static/media/filter_active.c001a66a.svg";